import { render, staticRenderFns } from "./EditPromo.vue?vue&type=template&id=54c33ee4"
import script from "./EditPromo.vue?vue&type=script&lang=js"
export * from "./EditPromo.vue?vue&type=script&lang=js"
import style0 from "./EditPromo.vue?vue&type=style&index=0&id=54c33ee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports